/*
 * @Description: 全局唯一的公共常量
 * @Author: 刘宝顺
 * @Date: 2024-02-01 14:16:23
 * @LastEditTime: 2024-03-19 14:23:00
 * @LastEditors: 刘宝顺
 */

import { COUNTRY_LANG_EN_US, COUNTRY_LANG_ZH_CN, LANGUAGE_CODE_AMERICA, LANGUAGE_CODE_CHINESE } from './country';

enum ECommonConst {}

/**
 * @option success 200
 * @option unauthorized 401
 */
export const RESPONSE_CODE = {
    success: 200,
    unauthorized: 401,
};
/**
 * @desc 支持语言种类 zh-CN en-US
 */
export const LANGUAGE_TYPES = [
    { label: 'English', value: COUNTRY_LANG_EN_US, code: LANGUAGE_CODE_AMERICA },
    { label: '简体中文', value: COUNTRY_LANG_ZH_CN, code: LANGUAGE_CODE_CHINESE },
];

export default ECommonConst;
